import Vue from 'vue'

export default {
    storeUsers: (state, users) => {
        Vue.set(state, 'users', users)
    }
}
